import { ShieldAlert } from "lucide-react";

import { useStaffOrg } from "@/contexts/StaffOrgContext";

/**
 * "Viewing <Org> as DigaVouch staff": on every page, for as long as a staff
 * member is switched into an org that is not their own. It names the org the
 * SERVER said the request acted in, so what it says is what the data is. The
 * person can go back to their own org from here, which matters on a phone or
 * a tablet where the header's switcher may be out of reach.
 */
export function StaffOrgBanner() {
  const staff = useStaffOrg();
  if (!staff || !staff.switched || !staff.viewingOrg) return null;

  const { viewingOrg, homeOrgId, homeOrgName, switching, switchTo } = staff;

  return (
    <div
      role="status"
      aria-live="polite"
      className="staff-org-banner relative z-10 w-full border-b border-trust-amber/40 bg-trust-amber/15 text-slate-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm">
        <p className="flex items-center gap-2 font-medium">
          <ShieldAlert className="h-4 w-4 shrink-0 text-trust-amber" aria-hidden="true" />
          <span>
            Viewing <strong>{viewingOrg.name}</strong> as DigaVouch staff
          </span>
        </p>
        {homeOrgId && (
          <button
            type="button"
            className="underline underline-offset-2 hover:text-slate-700 disabled:opacity-60"
            disabled={switching}
            onClick={() => void switchTo(null)}
          >
            {homeOrgName ? `Back to ${homeOrgName}` : "Back to your organization"}
          </button>
        )}
      </div>
    </div>
  );
}
